import DynamicVideo from "components/DynamicVideo"
import Link from "next/link"

export default function VideoReview({ video, category, title, slug }) {
  return (
    <div className="bg-white h-full flex flex-col items-center border-0.5 border-grey-cool">
      <DynamicVideo component={video[0].component} {...video[0]} title={video[0]?.title ?? title} />
      <h2 className="text-center p-8 flex flex-col justify-center h-full text-m1">
        {category.join(", ") ? (
          <span className="block text-base font-primary font-medium text-primary mb-3 capitalize">
            {category.join(", ").replaceAll("-", " ")}
          </span>
        ) : null}
        <Link href={slug}>
          <span className="text-primary hover:underline">{title}</span>
        </Link>
      </h2>
    </div>
  )
}
